import {Component, input, output} from '@angular/core';

@Component({
  selector: 'app-success',
  imports: [],
  templateUrl: './success.component.html',
  styleUrl: './success.component.scss'
})
export class SuccessComponent {
  message = input.required<string>({});
  close =  input<boolean>();
  onClose = output<void>();
  // _images = inject(ImagesService);

  closeToast() {
    this.onClose.emit();
  }
}
